import { createFileRoute } from '@tanstack/react-router'
import { Movement } from '../screens/Movement'

function MovementRoute() {
  const { accountId } = Route.useParams()
  return <Movement accountId={accountId} />
}

export const Route = createFileRoute('/movement/$accountId')({
  component: MovementRoute,
})
